/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'PromptVersion'>;
const hooks = useModelQueries(schema, 'PromptVersion');

export const useAggregatePromptVersion: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountPromptVersion: Hooks['useCount'] = hooks.useCount;
export const useCreatePromptVersion: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyPromptVersion: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnPromptVersion: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeletePromptVersion: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyPromptVersion: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsPromptVersion: Hooks['useExists'] = hooks.useExists;
export const useFindFirstPromptVersion: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyPromptVersion: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniquePromptVersion: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByPromptVersion: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyPromptVersion: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregatePromptVersion: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountPromptVersion: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstPromptVersion: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyPromptVersion: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniquePromptVersion: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByPromptVersion: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyPromptVersion: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdatePromptVersion: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyPromptVersion: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnPromptVersion: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertPromptVersion: Hooks['useUpsert'] = hooks.useUpsert;
